import api from '@Services/api';
import { AxiosResponse } from 'axios';

import {
	ApplyTemplateResult,
	InstructorUsageRow,
	PagedPayload,
	UpdateVideoProviderPayload,
	UsageMeta,
	VideoProviderContainer,
	VideoProviderSetting,
} from '../Types/VideoProviders.types';

/** The usage endpoint returns a non-Lucid meta ({total, page, per_page}). */
export type UsageResponse = Omit<
	ApiResponse<{ usage: InstructorUsageRow[] }>,
	'meta'
> & { meta: UsageMeta };

/**
 * Settings -> Video Providers. Admin-only endpoints; secrets are write-only
 * (GET/PUT responses mask them as {has_value, hint}).
 */
export class VideoProviderSettingsRequester {
	private static instance: VideoProviderSettingsRequester;
	static getInstance() {
		if (!VideoProviderSettingsRequester.instance) {
			VideoProviderSettingsRequester.instance =
				new VideoProviderSettingsRequester();
		}
		return VideoProviderSettingsRequester.instance;
	}
	baseURL = 'settings/video-providers';

	async getAll(): Promise<
		AxiosResponse<ApiResponse<{ providers: VideoProviderSetting[] }>>
	> {
		return await api.get(`${this.baseURL}`);
	}

	async update(
		payload: UpdateVideoProviderPayload
	): Promise<AxiosResponse<ApiResponse<{ providers: VideoProviderSetting[] }>>> {
		return await api.put(`${this.baseURL}`, payload);
	}

	async containers(
		payload: PagedPayload
	): Promise<
		AxiosResponse<ApiResponse<{ containers: VideoProviderContainer[] }>>
	> {
		return await api.post(`${this.baseURL}/containers`, payload);
	}

	async applyBunnyTemplate(): Promise<
		AxiosResponse<ApiResponse<ApplyTemplateResult>>
	> {
		return await api.post(`${this.baseURL}/bunny/apply-template`);
	}

	async usage(payload: PagedPayload): Promise<AxiosResponse<UsageResponse>> {
		return await api.post(`${this.baseURL}/usage`, payload);
	}
}
